import {
  Block,
  Button,
  List,
  ListInput,
  ListItem,
  Page,
  Popup,
} from "framework7-react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import PopupNavbar from "../../components/popup-navbar";
import { requests } from "../../constants/requests";
import { usePopupBackClose } from "../../hooks/use-back-close";
import { useEnterKeys } from "../../hooks/use-enter-keys";
import { vibrate } from "../../hooks/use-haptics";
import { useIsPending } from "../../hooks/use-is-pending";
import { useToast } from "../../hooks/use-toast";
import { redeemTransferCode } from "../../redux/reducer/session-transfer";
import {
  isCompleteTransferCode,
  normalizeTransferCode,
} from "../../utils/transfer-code";

const RedeemPopup = ({ opened, onClose = () => {}, onRedeemed = () => {} }) => {
  const [code, setCode] = useState("");
  const backClose = usePopupBackClose(opened);
  useEnterKeys(backClose.id, { "transfer-code-input": { hint: "go" } });
  const isPending = useIsPending(requests.redeemTransferCode);
  const { showError } = useToast();
  const dispatch = useDispatch();
  const canSubmit = isCompleteTransferCode(code) && !isPending;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!canSubmit) return;
    dispatch(
      redeemTransferCode(
        code,
        () => {
          vibrate();
          onRedeemed();
        },
        showError,
      ),
    );
  };

  return (
    <Popup
      {...backClose}
      className="redeem-popup"
      opened={opened}
      // autofocus does nothing on an input inside a hidden popup.
      onPopupOpened={(popup) =>
        popup.el.querySelector("input[name=transfer-code-input]")?.focus()
      }
      onPopupClosed={() => {
        setCode("");
        onClose();
      }}
    >
      <Page>
        <PopupNavbar title="Code eingeben" />
        <Block>
          <List strong form formStore={false} onSubmit={handleSubmit}>
            <ListInput
              name="transfer-code-input"
              outline
              type="text"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="characters"
              spellcheck={false}
              required
              placeholder="XXXX XXXX"
              value={code}
              onChange={(event) =>
                setCode(normalizeTransferCode(event.target.value))
              }
              className="uppercase transfer-code-input"
            />
            <ListItem>
              Den Code zeigt Split It im Browser oder auf deinem anderen Gerät
              unter „Auf anderem Gerät öffnen“ im Menü.
            </ListItem>
            <ListItem>
              <Button type="submit" fill disabled={!canSubmit}>
                Übernehmen
              </Button>
            </ListItem>
          </List>
        </Block>
      </Page>
    </Popup>
  );
};

export default RedeemPopup;
